import { useEffect, useState } from 'react';
import { useAuth } from './lib/auth.js';
import { applyUpdate, registerServiceWorker } from './lib/sw-register.js';
import { AuthScreen } from './components/AuthScreen.js';
import { Dashboard } from './components/Dashboard.js';

export function App() {
  const { user, loading } = useAuth();
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    void registerServiceWorker({ onUpdateAvailable: () => setUpdateAvailable(true) });
  }, []);

  if (loading) {
    return (
      <main className="auth">
        <section className="auth__pitch">
          <div className="brand">
            <span>Ephemeris</span>
          </div>
        </section>
      </main>
    );
  }

  return (
    <>
      {updateAvailable ? (
        <div className="banner" role="status">
          <span>Une nouvelle version est disponible.</span>
          <button type="button" className="linkbtn" onClick={() => void applyUpdate()}>
            Recharger
          </button>
        </div>
      ) : null}

      {user ? <Dashboard /> : <AuthScreen />}
    </>
  );
}
